export const getVariantColor = rangeStatus => {
  if (!rangeStatus) return null;

  if (
    ["borderline high", "borderline low", "border-high", "border-low", "border high", "border low"].includes(
      rangeStatus.toLowerCase(),
    )
  ) {
    return "warning";
  }

  if (["high", "low"].includes(rangeStatus.toLowerCase())) {
    return "danger";
  }

  if (["negative", "positive"].includes(rangeStatus.toLowerCase())) {
    return "blue";
  }

  if (["myform"].includes(rangeStatus)) return "violet";

  return "success";
};
